export default {
      id: "chart-usage",
      viewBox: "0 0 18 17",
      url: __webpack_public_path__ + "img/svg.c2d72070.svg#chart",
      toString: function () {
        return this.url;
      }
    }